import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    // Check localStorage on initialization
    const savedState = localStorage.getItem('sidebar-collapsed');
    return savedState === 'true';
  });

  // Apply the class to body when state changes
  useEffect(() => {
    if (isCollapsed) {
      document.body.classList.add('sidebar-collapsed');
    } else {
      document.body.classList.remove('sidebar-collapsed');
    }
    
    // Save to localStorage
    localStorage.setItem('sidebar-collapsed', isCollapsed.toString());
  }, [isCollapsed]);

  // Check for ReportHub specific state on mount
  useEffect(() => {
    const isReportHubPage = window.location.pathname.includes('/report-hub');
    if (isReportHubPage) {
      const reportHubState = localStorage.getItem('report-hub-sidebar-collapsed');
      if (reportHubState === 'true') {
        setIsCollapsed(true);
      }
    }
  }, []);

  const toggleSidebar = () => {
    setIsCollapsed(prev => !prev);
  };

  const collapseSidebar = () => {
    setIsCollapsed(true);
  };

  const expandSidebar = () => {
    setIsCollapsed(false);
  };

  // ReportHub specific functions
  const collapseSidebarForReportHub = () => {
    localStorage.setItem('report-hub-sidebar-collapsed', 'true');
    setIsCollapsed(true);
  };

  const expandSidebarForReportHub = () => {
    localStorage.setItem('report-hub-sidebar-collapsed', 'false');
    setIsCollapsed(false);
  };

  const value = {
    isCollapsed,
    toggleSidebar,
    collapseSidebar,
    expandSidebar,
    collapseSidebarForReportHub,
    expandSidebarForReportHub,
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};
